import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material";

type Props = Readonly<{
	open: boolean;
	handleClose: () => void;
	handleRemoveClick: () => void;
}>;

const DeleteDialog = ({ open, handleClose, handleRemoveClick }: Props) => {
	const { t } = useTranslation();

	return (
		<Dialog
			fullWidth={true}
			open={open}
			onClose={handleClose}
		>
			<DialogTitle>{t("teditor.deleteTitle")}</DialogTitle>
			<DialogContent>
				<DialogContentText>
					{t("teditor.deleteMsg")}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button color="danger" onClick={handleRemoveClick} style={{ marginRight: 5 }}>{t("teditor.remove")}</Button>
				<Button color="inherit" onClick={handleClose}>{t("dialog.cancel")}</Button>
			</DialogActions>
		</Dialog>
	);
};

export default DeleteDialog;
